import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconVideoSkip15 = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M10.527 21.504C5.142 21.52.765 17.166.75 11.781.735 6.396 5.088 2.02 10.473 2.004c5.385-.015 9.762 4.338 9.777 9.723l.002.75",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M23.244 9.466l-2.992 3.008-3.008-2.991",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.973 20.497l1.008-.003-.015-5.636-1.004.003-1.47 1.039.003.949 1.4-.996h.066l.012 4.644zm4.657.128c1.23-.003 2.053-.814 2.05-1.994-.004-1.133-.787-1.853-1.752-1.85-.574.001-.988.198-1.237.546h-.066l.152-1.649 2.593-.007-.002-.828-3.379.01-.3 3.277.915-.002c.19-.372.56-.596 1.041-.597.621-.002 1.06.447 1.062 1.118.002.692-.435 1.154-1.083 1.156-.574.001-1.009-.345-1.073-.872l-.941.002c.046.988.856 1.693 2.02 1.69z",
      fill: color
    })]
  }));
});
IconVideoSkip15.displayName = "IconVideoSkip15";

export { IconVideoSkip15 };
